import { FC, ReactNode } from "react";
import Button from "@blanket/components/buttons/Button";

interface TooltippedRemoveButtonProps {
  onClick: () => void;
  ariaLabel: string;
  children: ReactNode;
  disabled?: boolean;
  tooltipContent?: string;
  className?: string;
}

const TooltippedRemoveButton: FC<TooltippedRemoveButtonProps> = ({
  onClick,
  ariaLabel,
  children,
  disabled = false,
  tooltipContent,
  className,
}) => {
  const button = (
    <Button
      type="button"
      variant="outline-danger"
      size="sm"
      onClick={onClick}
      aria-label={ariaLabel}
      disabled={disabled}
      fullWidth={false}
      className={className}
    >
      {children}
    </Button>
  );

  if (disabled && tooltipContent) {
    return (
      <span
        tabIndex={0}
        title={typeof tooltipContent === "string" ? tooltipContent : undefined}
        className="d-inline-block"
      >
        {button}
      </span>
    );
  }

  return button;
};

export default TooltippedRemoveButton;
